import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, FlatButton } from 'material-ui'
import styles from './link-styles'

const SocialLinksHelperDialog = ({ toggleDialog }) => {
  return (
    <Dialog open>
      <div>
        <h2>Social Links</h2>
        <p>
          These links can be inserted in any of the Reviews Message Settings using
          using the following tags:
        </p>
        <ul style={styles.tagList}>
          <li style={styles.tag}>@location_facebook_url</li>
          <li style={styles.tag}>@location_google_url</li>
          <li style={styles.tag}>@location_yelp_url</li>
        </ul>
        <p>
          <span style={{ fontWeight: 'bold' }}>Note: </span>If you plan to use one of
          the links, make sure each location has its version of the link filled out.
          For example, if you have three locations and you are using
          <span style={styles.tag}>@location_facebook_url</span> in a message setting,
          make sure the Facebook link is not empty for any location. If a location's
          version is empty, it will show blank for that location's emails/texts.
        </p>
        <p>
          <a href="https://support.google.com/business/answer/7035772?hl=en" target="_blank">Click here </a>
           to learn how to keep Google's link as short as the other two.
        </p>
      </div>
      <FlatButton
        label="Close"
        onClick={() => toggleDialog(false)}
      />
    </Dialog>
  )
}

SocialLinksHelperDialog.propTypes = {
  toggleDialog: PropTypes.func.isRequired,
}

export default SocialLinksHelperDialog



// WEBPACK FOOTER //
// ./src/components/Settings/PostApptReviewMessageEditor/SocialLinksHelpDialog.js